import { Box } from '@material-ui/core';
import { useAppContext } from 'core/contexts';
import SGSMuiStepperDotted from 'features/arretTravail/components/SGSMuiStepper';
import { useFetchContractsPrev } from 'features/arretTravail/hooks/useFetchContractsPrev';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SearchFormProvider } from '../../../contexts/SearchFormProvider';
import { resetSearchParams as resetSearchParamsContracts } from '../../../redux/searchParamsSliceContracts';
import { resetSearchParams as resetSearchParamsSubscribers } from '../../../redux/searchParamsSliceSubscribers';
import FormSearchAffilieContract from './affilieSearch';
import FormSearchContract from './ContractSearch';
import FormSearchSubscriber from './SubscriberSearch';

interface Props {}

const FormWorkStoppageSearch: React.FC<Props> = () => {
    const { user } = useAppContext();
    const dispatch = useDispatch();
    const [activeStep, setActiveStep] = useState(0);

    // preload
    useFetchContractsPrev(user);

    useEffect(() => {
        // Reset search
        return () => {
            dispatch(resetSearchParamsSubscribers());
            dispatch(resetSearchParamsContracts());
        };
    }, []);

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };

    const steps = ['Souscripteur', 'Contrat', 'Assuré'];

    const renderStepContent = () => {
        switch (activeStep) {
            case 0:
                return <FormSearchSubscriber handleTabChange={handleStepChange} />;
            case 1:
                return <FormSearchContract handleTabChange={handleStepChange} />;
            case 2:
                return <FormSearchAffilieContract />;
            default:
                return null;
        }
    };

    return (
        <Box>
            <SGSMuiStepperDotted
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                stepFailed={null} // Optional: Pass a failure state if required
                displayLabel
            />
            <SearchFormProvider>
                <Box className="mt-4"></Box>
                <Box role="tabpanel" id={`step-${activeStep}`} aria-labelledby={`step-${activeStep}`}>
                    {renderStepContent()}
                </Box>
            </SearchFormProvider>
        </Box>
    );
};

export default FormWorkStoppageSearch;
